<template>
  <div class="promotion-table-container">
    <promotionFormAllProvince
      :selected_item="selected_item"
      :dialog="promotionDialogAllProvince"
      @setDialog="promotionDialogAllProvince = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      @onSaved="
        promotionList = $event;
        editedIndex = -1;
        promotionDialogAllProvince = false;
      "
    />
    <promotionFormByProvince
      :selected_item="selected_item"
      :dialog="promotionDialogByProvince"
      @setDialog="promotionDialogByProvince = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      @onSaved="
        promotionList = $event;
        editedIndex = -1;
        promotionDialogByProvince = false;
      "
      :province="province"
    />
    <v-layout row class="mt-2 mb-1">
      <v-flex xs12>
        <v-toolbar flat class="promo-toolbar elevation-1">
          <div class="toolbar-left d-flex align-center">
            <v-icon small class="mr-2 ci-accent">local_offer</v-icon>
            <div class="toolbar-title">Promotions</div>
            <v-chip small class="count-chip" v-if="promotionList.length">{{
              promotionList.length
            }}</v-chip>
            <v-btn
              class="add-promo-btn inline"
              v-if="!isEditPromotion && isAllProvinceMode"
              small
              @click="promotionDialogAllProvince = true"
            >
              <v-icon small left>add</v-icon>
              <span class="hidden-xs-only">Add</span>
            </v-btn>
            <v-btn
              class="add-promo-btn inline"
              v-if="!isEditPromotion && province"
              small
              @click="promotionDialogByProvince = true"
            >
              <v-icon small left>add</v-icon>
              <span class="hidden-xs-only">Add</span>
            </v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat dense class="promo-sub-toolbar elevation-1 mt-3">
          <div class="sub-toolbar-actions d-flex align-center flex-wrap">
            <div class="search-wrapper">
              <v-text-field
                v-model="search"
                prepend-inner-icon="search"
                placeholder="Search code / name"
                single-line
                clearable
                hide-details
                class="search-field inner-icon"
              ></v-text-field>
            </div>
            <v-btn
              v-if="!isMobile"
              small
              class="filter-toggle ml-2"
              @click="showFilters = !showFilters"
              :title="showFilters ? 'Hide filters' : 'Show filters'"
            >
              <v-icon left small>filter_list</v-icon>
              <span class="hidden-xs-only">Filters</span>
              <v-icon
                small
                class="ml-1 rotate-icon"
                :class="{ open: showFilters }"
                >expand_more</v-icon
              >
            </v-btn>
          </div>
        </v-toolbar>
        <transition name="expand-fade">
          <div
            v-show="showFilters"
            class="filters-expand elevation-1"
            :class="{ mobile: isMobile }"
          >
            <div class="filter-row">
              <div class="filter-item order-type-wrapper">
                <v-select
                  v-model="orderTypeFilter"
                  :items="orderTypeOptions"
                  item-text="text"
                  item-value="value"
                  hide-details
                  solo
                  prepend-inner-icon="view_list"
                  class="order-type-filter pill-select"
                  label="Order type"
                  dense
                ></v-select>
              </div>
              <div class="active-filter-chips" v-if="orderTypeFilter !== 'all'">
                <v-chip close small @input="resetOrderType" class="active-chip">
                  {{ displayOrderType(orderTypeFilter) }}
                </v-chip>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                small
                flat
                class="ml-2 reset-btn"
                @click="resetAllFilters"
                v-if="anyFilterActive"
                >Reset</v-btn
              >
            </div>
          </div>
        </transition>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="displayedHeaders"
      :items="filteredPromotionList"
      :pagination.sync="pagination"
      :loading="loading_message"
      :rows-per-page-items="[25, 50, 100, 500, 1000, 2000]"
      class="promotion-table elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ promotionList.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-left">{{ filterOrderType(props.item) }}</td>
        <td class="text-xs-left promo-code-cell">
          {{ props.item.promotion_code }}
        </td>
        <td class="text-xs-left promo-name-cell">
          {{ props.item.promotion_name_th }}
        </td>
        <td class="text-xs-left promo-type-chip">
          <span class="type-chip">{{ filterPromoType(props.item) }}</span>
        </td>
        <td class="text-xs-right">
          {{
            props.item.promotion_discount + " " + filterPromoUnit(props.item)
          }}
        </td>
        <td class="text-xs-right used-total-cell">
          {{ formatUsedTotal(props.item) }}
        </td>
        <td class="text-xs-center">{{ props.item.promotion_start_date }}</td>
        <td class="text-xs-center">{{ props.item.promotion_end_date }}</td>
        <td class="text-xs-center" v-if="isAllProvinceMode || province">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :to="
                isAllProvinceMode
                  ? '/weserve_admin_login/-/promotion-manage/promotion-log/' +
                    props.item.promotion_id
                  : `/weserve_admin_login/control/${province}/food/${props.item.promotion_id}/promotionlog`
              "
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View log</span>
          </v-tooltip>
        </td>
        <td
          class="justify-center layout px-0 action-col"
          v-if="isAllProvinceMode || province"
        >
          <v-tooltip top>
            <v-btn
              icon
              @click="editPromotion(props.item, isAllProvinceMode)"
              slot="activator"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :loading="deletingPromoId.includes(props.item.promotion_id)"
              @click="deletePromotion(props.item)"
              v-if="!isEditPromotion"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false" class="text-xs-center">
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import promotionFormAllProvince from "./PromotionForm";
import { mapGetters } from "vuex";
import promotionFormByProvince from "@/components/back-office/Promotion/PromotionForm.vue";
export default {
  props: {
    promotionListExternal: { type: Array, default: null },
    loadingExternal: { type: Boolean, default: false },
    isAllProvince: { type: Boolean, default: null },
    province: { type: String, default: null },
  },
  data: () => ({
    deletingPromoId: [],
    promotionList: [],
    loading_message: false,
    selected_item: {},
    search: "",
    orderTypeFilter: "all",
    showFilters: false,
    isMobile: false,
    promotionDialogAllProvince: false,
    promotionDialogByProvince: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 25,
    },
    orderTypeOptions: [
      { text: "All types", value: "all" },
      { text: "Food", value: 1 },
      { text: "Messenger", value: 2 },
      { text: "Free", value: 3 },
      { text: "Wellness", value: 4 },
      { text: "Car hiring", value: 5 },
      { text: "Other", value: "other" },
    ],
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Order type",
        align: "center",
        value: "promotion_order_type_name_temp",
        sortable: false,
      },
      {
        text: "Code",
        align: "center",
        value: "promotion_code",
        sortable: false,
      },
      {
        text: "Name",
        align: "center",
        value: "promotion_name_th",
        sortable: false,
      },
      {
        text: "Type",
        align: "center",
        value: "promotion_type_name_temp",
        sortable: false,
      },
      {
        text: "Discount",
        align: "center",
        value: "promotion_discount",
        sortable: false,
      },
      {
        text: "Used / Total",
        align: "center",
        value: "promotion_amount",
        sortable: false,
      },
      {
        text: "Start",
        align: "center",
        value: "promotion_start_date",
        sortable: false,
      },
      {
        text: "End",
        align: "center",
        value: "promotion_end_date",
        sortable: false,
      },
      {
        text: "Log",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "name",
        sortable: false,
      },
    ],
  }),
  components: {
    promotionFormAllProvince,
    promotionFormByProvince,
  },
  computed: {
    ...mapGetters({
      isEditPromotion: "isEditPromotion",
    }),
    isAllProvinceMode() {
      if (this.isAllProvince !== null) return this.isAllProvince;
      if (this.province) return false; // explicit province mode
      const first = this.promotionList[0];
      if (!first) return true; // default until data arrives
      return Array.isArray(first.promotion_province_condition);
    },
    displayedHeaders() {
      return this.headers; // show all now, even in province mode
    },
    filteredPromotionList() {
      if (!this.promotionList || this.promotionList.length === 0) return [];
      const searchLower = this.search.trim().toLowerCase();
      const filter = this.orderTypeFilter;
      return this.promotionList.filter((val) => {
        if (searchLower) {
          const code = (val.promotion_code || "").toLowerCase();
          const name = (val.promotion_name_th || "").toLowerCase();
          if (!code.includes(searchLower) && !name.includes(searchLower)) {
            return false;
          }
        }
        if (filter !== "all") {
          const orderTypeNum = Number(val.promotion_order_type);
          if (filter === "other") {
            if ([1, 2, 3, 4, 5].includes(orderTypeNum)) return false;
          } else if (orderTypeNum !== Number(filter)) return false;
        }
        return true;
      });
    },
    pages() {
      if (!this.pagination) return 0;
      this.$set(this.pagination, "totalItems", this.promotionList.length);
      const rpp = this.pagination.rowsPerPage;
      if (!rpp) return 0;
      return Math.ceil(this.pagination.totalItems / rpp);
    },
    anyFilterActive() {
      return this.orderTypeFilter !== "all";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    // Only self-initialize when parent didn't pass external list
    if (this.promotionListExternal === null) {
      this.initialize();
    } else {
      // Use external loading flag
      this.loading_message = this.loadingExternal;
      this.promotionList = this.promotionListExternal;
    }
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsMobile);
  },
  methods: {
    async initialize() {
      this.loading_message = true;
      this.promotionList = await this.$store.dispatch(
        "fetchFoodPromotionBack/fetchPromoListAllProvince"
      );
      this.loading_message = false;
    },
    updateIsMobile() {
      // threshold 600px considered mobile
      const mobile = window.innerWidth <= 600;
      if (mobile && !this.isMobile) {
        // entering mobile
        this.showFilters = true; // auto expand
      }
      this.isMobile = mobile;
    },
    refreshList() {
      if (this.promotionListExternal === null) {
        this.initialize();
      } else {
        this.$emit("refresh");
      }
    },
    filterPromoUnit(item) {
      if (item.promotion_unit == 1) {
        return "฿";
      } else {
        return "%";
      }
    },
    filterPromoType(item) {
      if (item.promotion_order_type == 5) {
        if (item.promotion_type == 3) {
          return "Total";
        }
      }

      if (item.promotion_type == 1) {
        return "Product";
      } else if (item.promotion_type == 2) {
        return "Transfer";
      } else if (item.promotion_type == 3) {
        return "Product and transfer";
      }

      return "Other";
    },
    filterOrderType(item) {
      if (item.promotion_order_type == 1) {
        return "Food";
      } else if (item.promotion_order_type == 2) {
        return "Messenger";
      } else if (item.promotion_order_type == 3) {
        return "Free";
      } else if (item.promotion_order_type == 4) {
        return "Wellness";
      } else if (item.promotion_order_type == 5) {
        return "Car hiring";
      }
      return "Other";
    },
    async deletePromotion(item) {
      let check = confirm("Do you want to delete this promotion ?");
      if (check == true) {
        this.deletingPromoId.push(item.promotion_id);
        let result;
        if (this.province) {
          result = await this.$store.dispatch(
            "fetchFoodPromotionBack/deletePromotionDetail",
            { promotion_id: item.promotion_id, province: this.province }
          );
        } else {
          result = await this.$store.dispatch(
            "fetchFoodPromotionBack/deletePromotionAllProvince",
            item.promotion_id
          );
        }
        let indexDelete = this.deletingPromoId.findIndex(
          (val) => val == item.promotion_id
        );
        this.deletingPromoId.splice(indexDelete, 1);
        if (result == false) return;
        // When province API returns updated list, prefer that; else splice
        if (Array.isArray(result)) {
          this.promotionList = result;
        } else {
          let index = this.promotionList.findIndex(
            (val) => val.promotion_id == item.promotion_id
          );
          if (index > -1) this.promotionList.splice(index, 1);
        }
      }
    },
    editPromotion(item, isAllProvince) {
      this.selected_item = item;
      if (isAllProvince) {
        this.promotionDialogAllProvince = true;
      } else {
        this.promotionDialogByProvince = true;
      }
      this.editedIndex = 1;
    },

    formatUsedTotal(item) {
      // All-province API structure contains promotion_province_condition array
      if (
        item &&
        item.promotion_province_condition &&
        Array.isArray(item.promotion_province_condition) &&
        item.promotion_province_condition.length > 0
      ) {
        const cond = item.promotion_province_condition[0] || {};
        return (cond.used_amount || 0) + " / " + (cond.total_amount || 0);
      }
      // Province-specific API returns promotion_use & promotion_amount directly
      if (
        item &&
        (item.promotion_use !== undefined ||
          item.promotion_amount !== undefined)
      ) {
        return (item.promotion_use || 0) + " / " + (item.promotion_amount || 0);
      }
      return "";
    },
    resetOrderType() {
      this.orderTypeFilter = "all";
    },
    resetAllFilters() {
      this.resetOrderType();
    },
    displayOrderType(val) {
      const map = {
        1: "Food",
        2: "Messenger",
        3: "Free",
        4: "Wellness",
        5: "Car hiring",
        other: "Other",
      };
      return map[val] || "Unknown";
    },
  },
  watch: {
    promotionListExternal: {
      handler(val) {
        if (val !== null) {
          this.promotionList = val;
        }
      },
      deep: true,
    },
    loadingExternal(val) {
      if (this.promotionListExternal !== null) {
        this.loading_message = val;
      }
    },
    // When list content changes, re-evaluate mode if auto-detecting
    promotionList: {
      handler() {
        // Trigger recompute (no-op body) for isAllProvinceMode
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.promotion-table-container {
  position: relative;
  padding-top: 8px;
}

/* Add button redesigned */
.add-promo-btn {
  background: #fddf00 !important;
  color: #000 !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  border-radius: 28px;
  padding: 0 18px !important;
  height: 42px !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  gap: 6px;
  transition: box-shadow 0.2s, transform 0.15s, background 0.2s;
}
.add-promo-btn .v-icon {
  color: #000 !important;
}
.add-promo-btn:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  background: #ffe73a !important;
}
.add-promo-btn:active {
  transform: translateY(1px);
}
.add-promo-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px #000, 0 0 0 4px #fddf00;
}
@media (max-width: 600px) {
  .add-promo-btn {
    padding: 0 12px !important;
    height: 40px !important;
  }
  .add-promo-btn .btn-label {
    display: none;
  }
}

/* Toolbar */
.promo-toolbar {
  background: linear-gradient(90deg, #ffffff 0%, #fff9c7 100%);
  border-left: 5px solid #fddf00;
  border-radius: 8px;
  min-height: 60px;
  padding: 0 8px;
  position: relative;
}
.promo-sub-toolbar {
  margin-top: 4px;
  background: #ffffff;
  border-left: 5px solid #ffe73a;
  border-radius: 8px;
  min-height: 56px;
  padding: 0 10px;
  display: flex;
  align-items: center;
}
.promo-toolbar .v-toolbar__content {
  padding-left: 12px !important;
}
.promo-sub-toolbar .v-toolbar__content {
  padding: 0 !important;
}

.toolbar-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #000;
}
.ci-accent {
  color: #000;
  background: #fddf00;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 0 0 2px #00000010;
}
.count-chip {
  background: #000 !important;
  color: #fddf00 !important;
  font-weight: 600;
}

.toolbar-actions .v-btn,
.toolbar-middle .v-btn {
  color: #000 !important;
}
.btn-density:hover {
  background: #fddf00 !important;
}

/* Removed density toggle styles (feature deprecated in redesign) */

/* Search field styling */
/* Search field inner icon style */
.search-wrapper {
  width: 280px;
  max-width: 100%;
}
.order-type-filter >>> .v-input__slot {
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 24px;
  padding: 0 8px;
  min-height: 38px;
  transition: all 0.2s;
}
.order-type-filter >>> .v-input__slot:hover {
  border-color: #b0b0b0;
}
.order-type-filter >>> .v-input__slot:focus-within {
  border-color: #fddf00;
  box-shadow: 0 0 0 2px #fddf0020;
}
.order-type-filter >>> .v-label {
  left: 14px !important;
}
.order-type-filter >>> .v-select__selections {
  font-size: 13px;
}
.order-type-filter >>> .v-input__append-inner .v-icon {
  color: #757575;
}
.search-field.inner-icon >>> .v-input__slot {
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 30px;
  padding-left: 14px;
  transition: all 0.2s;
}
.search-field.inner-icon >>> .v-input__slot:hover {
  border-color: #b0b0b0;
}
.search-field.inner-icon >>> .v-input__slot:focus-within {
  border-color: #fddf00;
  box-shadow: 0 0 0 2px #fddf0020;
}
.search-field.inner-icon >>> .v-label {
  left: 32px !important;
}
.search-field.inner-icon >>> .v-icon.v-icon {
  color: #757575;
}
.search-field.inner-icon >>> .v-input__append-inner {
  margin-right: 6px;
}
.search-field.inner-icon >>> input {
  font-size: 13px;
}
.search-field.inner-icon >>> .v-input__icon--append {
  order: 2;
}

/* Filters expansion panel */
.filters-expand {
  background: #ffffff;
  border-left: 5px solid #fddf00;
  border-radius: 0 0 8px 8px;
  margin-top: -4px;
  padding: 12px 16px 10px;
  position: relative;
}
.filters-expand.mobile {
  margin-top: 0;
  border-top: 1px solid #f5eeb1;
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
}
.filter-item {
  display: flex;
  flex-direction: column;
}
.pill-select >>> .v-input__slot {
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 30px;
  padding-left: 14px;
  transition: all 0.2s;
}
.pill-select >>> .v-input__slot:hover {
  border-color: #b0b0b0;
}
.pill-select >>> .v-input__slot:focus-within {
  border-color: #fddf00;
  box-shadow: 0 0 0 2px #fddf0020;
}
.pill-select >>> .v-label {
  left: 40px !important;
}
.pill-select >>> .v-icon.v-icon {
  color: #757575;
}

.filter-toggle {
  background: #fff9c7 !important;
  color: #000 !important;
  text-transform: none;
  font-weight: 600;
  border-radius: 24px;
  padding: 0 14px !important;
  height: 38px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: background 0.2s, box-shadow 0.2s;
}
.filter-toggle:hover {
  background: #ffe73a !important;
}
.filter-toggle .v-icon {
  color: #000 !important;
}
.rotate-icon {
  transition: transform 0.25s ease;
}
.rotate-icon.open {
  transform: rotate(180deg);
}

.active-filter-chips .active-chip {
  background: #000 !important;
  color: #fddf00 !important;
  font-weight: 600;
}
.reset-btn {
  text-transform: none;
  font-weight: 500;
}
.reset-btn:hover {
  background: #fddf00 !important;
}

/* Transition */
.expand-fade-enter-active,
.expand-fade-leave-active {
  transition: all 0.25s ease;
}
.expand-fade-enter,
.expand-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (max-width: 860px) {
  .filters-expand {
    border-left: none;
    border-top: 1px solid #eee;
    border-radius: 0 0 8px 8px;
  }
  .pill-select {
    flex: 1 1 100%;
  }
}

@media (max-width: 500px) {
  .filters-expand {
    padding: 10px 12px 8px;
  }
  .filter-toggle {
    height: 34px !important;
    padding: 0 12px !important;
  }
}

/* Inline add button variant inside toolbar */
.add-promo-btn.inline {
  position: relative;
  top: auto;
  right: auto;
  margin-left: 16px;
  height: 34px !important;
  padding: 0 14px !important;
}
.add-promo-btn.inline .v-icon {
  margin-right: 2px;
}

/* Table */
.promotion-table >>> thead tr {
  background: #fddf00;
}
.promotion-table >>> thead th {
  color: #000;
  font-weight: 600;
  font-size: 13px;
}
.promotion-table >>> tbody tr:hover {
  background: #fff9c7 !important;
}
.promotion-table >>> tbody td {
  font-size: 13px;
}

/* Code / Name emphasis */
.promo-code-cell {
  font-weight: 600;
  letter-spacing: 0.5px;
}
.promo-name-cell {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Type chip */
.type-chip {
  display: inline-block;
  background: #000;
  color: #fddf00;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Used / Total cell */
.used-total-cell {
  font-variant-numeric: tabular-nums;
}

/* Action buttons */
.action-col >>> .v-btn {
  transition: background-color 0.2s, transform 0.15s;
}
.action-col >>> .v-btn:hover {
  background: #fddf00 !important;
}
.action-col >>> .v-btn:active {
  transform: scale(0.9);
}

/* Legend */
.legend {
  font-size: 11px;
  color: #555;
  display: flex;
  align-items: center;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  border: 1px solid #9e9e9e;
}
.legend-dot.used {
  background: #fddf00;
}
.legend-dot.total {
  background: #eee;
}

/* Loading state alignment */
.v-progress-circular {
  margin-right: 8px;
}

/* Responsive tweaks */
@media (max-width: 960px) {
  .promo-name-cell {
    max-width: 140px;
  }
  .promo-toolbar {
    flex-wrap: wrap;
  }
  .legend {
    display: none !important;
  }
}

@media (max-width: 860px) {
  .toolbar-actions {
    flex-wrap: wrap;
    width: 100%;
    margin-top: 8px;
    justify-content: flex-start;
  }
  .search-wrapper {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }
  .order-type-filter {
    min-width: 200px;
  }
  .promo-sub-toolbar {
    flex-wrap: wrap;
    min-height: unset;
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

@media (max-width: 500px) {
  .add-promo-btn.inline {
    margin-left: 8px;
    height: 32px !important;
    padding: 0 10px !important;
  }
  .toolbar-title {
    font-size: 14px;
  }
  .search-wrapper {
    width: 100%;
  }
  .order-type-filter {
    width: 100%;
  }
}
</style>
